import soviet_union_apart from '../images/soviet_apart.jpg'
import jsah from '../images/jsah.png'
import mass_housing from '../images/mass_housing.png'
import grand_old from '../images/grand_old.jpg'
import new_books from '../images/new_books.jpg'
import exhibit_poster from '../images/insecurity_exhibit.jpg'
import back_porch from '../images/back_porch.jpg'
import cover_issue from '../images/green_cover.jpg'
import aerial_map from '../images/aerial_map.jpg'
import arcc from '../images/arcc.png'
import bnw_crane from '../images/bnw_crane.jpg'
import yk_fence from '../images/yk_fence.jpg'
import italians from '../images/italians.jpg'
import zupagrafika from '../images/zupagrafika.jpeg'
import archive2020 from '../images/archive2020.jpg'
import beyond_plaza from '../images/beyond_plaza2.jpeg'

export const projects = {
  soviet_union_apart_tile: {
    link: 'https://www.cornellpress.cornell.edu/book/9781501771200/taking-the-soviet-union-apart-room-by-room/#bookTabs=1',
    img: soviet_union_apart,
    blurb: 'Taking the Soviet Union Apart',
  },
  jsah_tile: {
    link: 'https://online.ucpress.edu/jsah/article-abstract/80/4/460/119541/Transforming-the-Architecture-of-FoodFrom-the',
    img: jsah,
    blurb: 'The Architecture of Food',
  },

  mass_housing_tile: {
    link: 'https://dom-publishers.com/products/mass-housing-in-ukraine-hardcover',
    img: mass_housing,
    blurb: 'Mass Housing in Ukraine',
  },
  grand_old_tile: {
    link: 'https://www.bauwelt.de/rubriken/betrifft/Odesa-Wohnungsbau-an-vorderster-Front-3863259.html',
    img: grand_old,
    blurb: 'Bauwelt: Odesa',
  },
  new_books_tile: {
    link: 'https://newbooksnetwork.com/taking-the-soviet-union-apart-room-by-room',
    img: new_books,
    blurb: 'Interview: Taking the Soviet Union Apart',
  },
  exhibit_poster_tile: {
    link: 'https://mississippihousing.wixsite.com/mshousingproject/',
    img: exhibit_poster,
    blurb: 'Housing Insecurity in Mississippi',
  },
  back_porch_tile: {
    link: 'https://www.platformspace.net/home/individually-generated-building-modifications-in-response-to-housing-precarity',
    img: back_porch,
    blurb: 'Individually Generated Building Modifications',
  },
  cover_issue_tile: {
    link: 'https://ewjus.com/index.php/ewjus/article/view/374',
    img: cover_issue,
    blurb: 'Monumental Landscapes and the Politics of Place',
  },
  aerial_map_tile: {
    link: 'https://www.platformspace.net/home/finding-shelter-from-russia-a-city-guide',
    img: aerial_map,
    blurb: 'Finding Shelter from Russia',
  },
  arcc_tile: {
    link: 'https://www.arcc-arch.org/meet-the-arcc-2024-awards-recipeints/',
    img: arcc,
    blurb: 'New Researcher Award',
  },
  bnw_crane_tile: {
    link: 'https://journal.eahn.org/article/id/7603/',
    img: bnw_crane,
    blurb: 'A Unit of Homemaking',
  },
  yk_fence_tile: {
    link: 'https://www.cca.qc.ca/en/events/95620/research-fellow-seminar-rural-mass-housing-in-ukraine',
    img: yk_fence,
    blurb: 'Housing Rural Ukraine',
  },
  italians_tile: {
    link: 'https://spectorbooks.com/book/what-s-next-for-mom-and-dad-s-house',
    img: italians,
    blurb: '“Invisible” User-Generated Change',
  },
  zupagrafika_tile: {
    link: 'https://zupagrafika.com/shop/eastern-blocks-volume-2',
    img: zupagrafika,
    blurb: 'Eastern Blocks II',
  },
  archive2020_tile: {
    link: 'https://archive-2020.biennial.ge/en/project/monumental-voids-and-the-new-political-common-space/17',
    img: archive2020,
    blurb: 'Monumental Voids',
  },
  beyond_plaza: {
    link: 'https://www.routledge.com/Protests-Beyond-the-Plaza-Everyday-Spaces-Urban-Morphologies-and-Strategies/Malaia-Hutson/p/book/9781032853840?srsltid=AfmBOooZde3yV3ACa0G7Tl76WxqV-ghDqdNVKZ_3EbugZEzv_6rfBfdQ-2020.biennial.ge/en/project/monumental-voids-and-the-new-political-common-space/17',
    img: beyond_plaza,
    blurb: 'Protests Beyond the Plaza',
  },
}
